import { get } from "jquery";

const formatedTime = (time) => {

    const timestamp = time;
    const date = new Date(timestamp);

    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');

    return `${hours}:${minutes}`;

}

function getTimeRow(time) {
    const date = new Date(time);

    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');

    const timerow = `time-${hours}${minutes}`;

    return timerow
}

function convertDateTimeToTime(dateTimeString) {
    // Skapa ett Date-objekt från den givna strängen
    const date = new Date(dateTimeString);

    // Formatera timmar och minuter
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');

    // Returnera formaterad sträng
    return `${hours}:${minutes}`;
}

function calculateDurationInMinutes(startsAt, endsAt) {
    const startDate = new Date(startsAt);
    const endDate = new Date(endsAt);
    const duration = endDate - startDate; // Skillnaden i millisekunder
    return duration / 60000; // Konvertera millisekunder till minuter
}


const setSpeakerUrl = (firstname, lastname) => {
    const cleanFirstname = firstname.toLowerCase().replace(/[^a-z\s]/g, '').replace(/\s+/g, '-');
    const cleanLastname = lastname.toLowerCase().replace(/[^a-z\s]/g, '').replace(/\s+/g, '-');

    const speakerUrl = cleanFirstname + "-" + cleanLastname;

    return speakerUrl;
}


const setSessionUrl = (title) => {
    const cleanTitle = title.toLowerCase().replace(/[^a-z\s]/g, '').replace(/\s+/g, '-');


    return cleanTitle;
}


export const SET_SESSIONS = (state, sessions) => {

    sessions = sessions.filter(session => session.categories.length)

    sessions = sessions.map(session => {

        const room = state.all.rooms.find(room => {
            return room.id === session.roomId
        })
        const weekDay = new Date(session.startsAt).getDay();

        //add timerow for css grid / Program view


        const timerow = getTimeRow(session.startsAt) + " / " + getTimeRow(session.endsAt)


        const start = formatedTime(session.startsAt)
        const end = formatedTime(session.endsAt)

        const sessionlength = calculateDurationInMinutes(session.startsAt, session.endsAt)

        const sessionType = session.categories.filter(cat => {

            if (cat.name == 'Track') {
                return true
            }
        })

        const speakerName = session.speakers.map(speaker => speaker.name).join(", ")
        const speakerNameArray = session.speakers.map(speaker => speaker.name).join(" ").split(" ")



        var sessiontags = []
        sessiontags.push(sessionType[0].categoryItems[0].name)

        const obj = {
            timerow,
            start,
            end,
            room,
            sessionlength,

            _id: session.id,
            conferencename: "session.conferencename,", // Statiskt värde, kan behöva justeras
            sessionDescription: session.description,
            sessionKeyTakeAway1: "sessionKeyTakeAway1",
            sessionKeyTakeAway2: "sessionKeyTakeAway2",
            sessionKeyTakeAway3: "sessionKeyTakeAway3",
            sessionSpeakerName: speakerName,
            //sessionTagMain: "Scientific", // Statiskt värde, kan behöva justeras
            //sessionTags: ["error", "scientific"], // Statiskt värde, kan behöva justeras
            sessionTitle: session.title,
            sessionTitleShort: "Anpassa detta fält efter behov",
            sessionTagMain: sessionType[0].categoryItems[0].name,
            sessionTags: sessiontags,
            //sessionType: 'scientific',
            sessionURL: setSessionUrl(session.title),
            sessionSpeakersOther: [],
            sessionScheduleDay: weekDay,
            sessionScheduleId: "§Q5NEpFJGgiEdMZaYf§AgyfqDGL2sPCs4Ycj§4", // Statiskt värde, kan behöva justeras
            sessionScheduleRoom: room.name, 
            sessionScheduleSlot: "4", // Statiskt värde, kan behöva justeras
            sessionSpeakerImagePuId: "2022_speakers/shv-cifs-dk", // Statiskt värde, kan behöva justeras
            sessionSpeakerURL: setSpeakerUrl(speakerNameArray[0], speakerNameArray[1]), // Statiskt värde, kan behöva justeras
            otherSpeakersShow: [],
            sessionScheduleTime: convertDateTimeToTime(session.startsAt)
        }

        return obj
    }
    )

    state.sessions = sessions;
}
export const SET_SPEAKERS = (state, speakers) => {


    const urls = new Set(); // Håll reda på alla unika URLs


    speakers = speakers.map(speaker => {

        let url = setSpeakerUrl(speaker.firstName, speaker.lastName);
        let counter = 1;

        // Om URL redan finns, lägg till en siffra tills den blir unik
        while (urls.has(url)) {
            url = `${setSpeakerUrl(speaker.firstName, speaker.lastName)}-${counter}`;
            counter++;
        }

        urls.add(url);

        const obj = {

            _id: speaker.id, // Detta värde verkar statiskt, kan behöva ändras
            speakerFirstName: speaker.firstName,
            speakerLastName: speaker.lastName,
            speakerURL: url, // Du behöver en logik för att generera detta värde
            speakerImagePuId: "anpassa-detta-fält-efter-behov", // Du behöver en logik för att generera detta värde
            speakerImageURL: speaker.profilePicture,
            speakerImageVersion: "1683198636", // Statiskt värde, kan behöva justeras
            speakerBiography: speaker.bio,
            speakerCompany: "Anpassa detta fält efter behov", // Du behöver en logik för att generera detta värde
            speakerSession: speaker.sessions.map(session => ({
                title: session.name,
                sId: session.id,
                url: setSessionUrl(session.name),
                scheduled: true, // Statiskt värde, kan behöva justeras
                description: "Anpassa detta fält efter behov", // Du behöver en logik för att generera detta värde
                takeAway1: "takeAway1",
                takeAway2: "takeAway2",
                takeAway3: "takeAway3",
                takeAway4: "takeAway4",
                scheduleDay: "3" // Statiskt värde, kan behöva justeras
            })),
            // speakerSessionTags: ["Leadership & Management", "Web", "Mobile", "Quality & Test"], // Statiskt värde, kan behöva justeras

            conferencename: "Øredev 2024" // Statiskt värde, kan behöva justeras
        }




        return obj

    }
    );

    state.speakers = speakers;
}
export const SET_TRACKS = (state, tracks) => {
    state.tracks = tracks;
}
export const SET_ALL = (state, all) => {
    state.all = all;
}
export const SET_GRID = (state, grid) => {
    state.grid = grid;
}
export const speakerUpdate = (state, payload) => {
    state.speaker = payload.speaker;
}
export const maproomUpdate = (state, payload) => {
    state.maproom = payload.room;
}
export const increment = (state) => {
    state.count++
}
export const decrement = (state) => {
    state.count--
}
export const setCount = (state, count) => {
    state.count = count;
}
export const setEffect = (state, boolean) => {
    state.effect = boolean;
}


// WEBPACK FOOTER //
// ./src/store/mutations.js